import { ContentType, Component } from 'contensis-core-api';
import SimpleMigrationService from './SimpleMigrationService';
import { Logger } from '~/util/logger';
import mapDuplicateAttributesToContentType from '~/transformations/mapDuplicateAttributesToContentType';
import { Duplicate, MigrateRequest } from '~/models/Operations';

type OperationResult = {
  components?: (Component | Error)[];
  contentTypes?: (ContentType | Error)[];
};

class DuplicateContentTypeService extends SimpleMigrationService {
  duplicate?: Duplicate;

  constructor(payload: MigrateRequest, preview: boolean) {
    super(payload, preview);
    const { duplicate } = payload;
    this.duplicate = duplicate;
  }

  Duplicate = async (migrate: {
    contentTypes?: ContentType[];
    components?: Component[];
  }) => {
    const result: OperationResult = {};

    result.components = await this.DuplicateComponents(migrate.components);
    result.contentTypes = await this.DuplicateContentTypes(
      migrate.contentTypes
    );

    Logger.info(`Done duplicating`, true);
    return result;
  };

  DuplicateComponents = async (components: Component[] = []) => {
    const results = [];
    for (const component of components) {
      Logger.info(`Duplicating component '${component.id}'`);

      const config = this.duplicate?.components.find(
        (dc: any) => dc.source === component.id
      );

      for (const target of config?.targets || []) {
        for (const [projectId, { repo }] of Object.entries(this.targetRepos)) {
          const mappedComponent = mapDuplicateAttributesToContentType(
            component,
            projectId,
            target
          ) as Component;

          let postedComponent: Component | undefined = mappedComponent;
          if (!this.isPreview)
            [, postedComponent] = await repo.UpsertComponent(
              false,
              mappedComponent
            );
          if (postedComponent) results.push(postedComponent);
        }
      }
    }
    return results;
  };

  DuplicateContentTypes = async (contentTypes: ContentType[] = []) => {
    const results = [];
    for (const contentType of contentTypes) {
      Logger.info(`Duplicating content type '${contentType.id}'`);

      const config = this.duplicate?.contentTypes.find(
        (dc: any) => dc.source === contentType.id
      );
      for (const target of config?.targets || []) {
        for (const [projectId, { repo }] of Object.entries(this.targetRepos)) {
          const mappedContentType = mapDuplicateAttributesToContentType(
            contentType,
            projectId,
            target
          ) as ContentType;

          let postedContentType: ContentType | undefined = mappedContentType;
          if (!this.isPreview)
            [, postedContentType] = await repo.UpsertContentType(
              false,
              mappedContentType
            );
          if (postedContentType) results.push(postedContentType);
        }
      }
    }
    return results;
  };
}

export default DuplicateContentTypeService;
